var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCohortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 41.25,
    height: 41.25,
    rx: 7.875,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 41.25,
    height: 41.25,
    rx: 7.875,
    stroke: "#E7E8E9",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8699 20.1525C18.7949 20.145 18.7049 20.145 18.6224 20.1525C16.8374 20.0925 15.4199 18.63 15.4199 16.83C15.4199 14.9925 16.9049 13.5 18.7499 13.5C20.5874 13.5 22.0799 14.9925 22.0799 16.83C22.0724 18.63 20.6549 20.0925 18.8699 20.1525Z",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3075 15C25.7625 15 26.9325 16.1775 26.9325 17.625C26.9325 19.0425 25.8075 20.1975 24.405 20.25C24.345 20.2425 24.2775 20.2425 24.21 20.25",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.12 22.92C13.305 24.135 13.305 26.115 15.12 27.3225C17.1825 28.7025 20.565 28.7025 22.6275 27.3225C24.4425 26.1075 24.4425 24.1275 22.6275 22.92C20.5725 21.5475 17.19 21.5475 15.12 22.92Z",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7549 27C26.2949 26.8875 26.8049 26.67 27.2249 26.3475C28.3949 25.47 28.3949 24.0225 27.2249 23.145C26.8124 22.83 26.3099 22.62 25.7774 22.5",
    stroke: "#292D32",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortIcon);
export default __webpack_public_path__ + "static/media/cohort-icon.540545c662c11d8ca04404152d83064b.svg";
export { ForwardRef as ReactComponent };